import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import Toast from "../../Utils/Toast";
import { Transaction_Login } from "../../Connections/Transaction";

import "../../Styles/Login.css";

const Login = (props) => {
  const navigate = useNavigate();

  //===========================================================
  const [searchParams, setSearchParams] = useSearchParams();
  const inviteId = searchParams.get("inviteId");
  const inviteType = searchParams.get("type");

  //===========================================================

  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  //===========================================================

  const handleSubmitLoginForm = (event) => {
    event.preventDefault();
    if (phoneNumber.length === 11 && phoneNumber.startsWith("09")) {
      setLoading(true);
      setError(false);

      const form = new FormData();
      form.append("mobile", phoneNumber);
      form.append("shadUserId", localStorage.getItem("shadUserId"));
      form.append("inviteCode", inviteId);
      form.append("inviteType", inviteType);
      Transaction_Login.Login(form)
        .then(() => {
          Toast("success", "کد ارسال شد");
          setLoading(false);
          navigate("/confirm-phone-number", {
            state: { prevPage: "login", phoneNumber: phoneNumber },
          });
        })
        .catch((err) => {
          console.log(err);
          Toast("error", err);
        });
    } else {
      setError("شماره وارد شده معتبر نمی‌باشد!");
    }
  };

  return (
    <div className="Login_page-wrapper">
      <div className="Login_wrapper-left-side">
        <img
          className="Login_wrapper-left-side-image"
          src="imgs/Login/Mobile-login-image.png"
          alt="Desktop-login-banner"
        />
      </div>
      <div className="login_wrapper-top">
        <img
          className="Login_wrapper-Top-side-image"
          src="imgs/Login/Mobile-login-image.png"
          alt="Mobile-login-banner"
        />
      </div>
      <div className="Login_wrapper-right-side">
        <div className="Login_wrapper-right-side-container">
          <h3 className="Login_wrapper-right-side-container-title">
            ورود به کتابنو
          </h3>
          <form
            className="Login_wrapper-right-side-container-form"
            onSubmit={handleSubmitLoginForm}
          >
            <input
              type="tel"
              maxLength={11}
              required
              className={`Login_wrapper-right-side-container-form-input-number ${
                error ? "input-error" : ""
              }`}
              value={phoneNumber}
              onChange={(e) =>
                isNaN(e.target.value) ? null : setPhoneNumber(e.target.value)
              }
            />
            <p
              className={`Login_wrapper-right-side-container-form-item-label ${
                error ? "label-error" : ""
              }`}
            >
              شماره موبایل خودت رو وارد کن
            </p>
            {phoneNumber.length > 0 ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="Login_wrapper-right-side-container-form-item-Delete"
                onClick={() => {
                  setPhoneNumber("");
                  setError(false);
                }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : null}

            {!loading ? (
              <button
                id="sendMobilephoneLogin"
                className={`Login_wrapper-right-side-container-form-button-send send-mobilephone-login`}
                type="submit"
                disabled={phoneNumber.length !== 11}
              >
                <span
                  className={
                    phoneNumber.length === 11
                      ? "Login_wrapper-right-side-container-form-button-send-after"
                      : ""
                  }
                >
                  ارسال کد
                </span>
              </button>
            ) : (
              <div
                className={`Login_wrapper-right-side-container-form-button-send`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  className={`Login_wrapper-right-side-container-form-button-send-load ${
                    phoneNumber.length === 11
                      ? "Login_wrapper-right-side-container-form-button-send-after"
                      : ""
                  }`}
                >
                  <LoadingSpinner />
                </span>
              </div>
            )}
          </form>
          {error ? (
            <p className="Login_wrapper-right-side-container-form-error-text">
              {error}
            </p>
          ) : null}
          <div className="Login_wrapper-right-side-container-footer">
            <p className="Login_wrapper-right-side-container-footer-text">
              حساب کاربری ندارم !{" "}
              <Link
                className="Login_wrapper-right-side-container-footer-text-register"
                id="Register-login"
                to="/register"
              >
                ثبت نام
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
